import ActionsForm from '@/shared/mixins/actionsForm'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'

export default {
  name: 'aprItemDetails',
  props: ['apr'],
  components: {},
  mixins: [ActionsForm],
  data () {
    return {
      openSections: [],
      dataItensAPR: [
        {
          nome: 'EPI',
          itens: []
        },
        {
          nome: 'FERRAMENTAS',
          itens: []
        },
        {
          nome: 'RISCOS ESPECIAIS',
          itens: []
        },
        {
          nome: 'CURSOS NR',
          itens: []
        }
      ],
      fieldMapping: {
        'EPI': 'nomeEPI',
        'FERRAMENTAS': 'nomeFerramentas',
        'RISCOS ESPECIAIS': 'nomeRiscosEspecial',
        'CURSOS NR': 'nomeCursosNr'
      }
    }
  },
  watch: {
    apr: {
      handler (newVal) {
        if (newVal && newVal.id) {
          this.getFerramentasPDF(newVal.id)
          this.getEPIPDF(newVal.id)
          this.getRiscosEspeciaisPDF(newVal.id)
          this.getCursosNRPDF(newVal.id)
        }
      },
      immediate: true // chama o handler se apr já vier populado
    }
  },
  mounted () {

  },
  methods: {
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    async getFerramentasPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetFerramentasByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.dataItensAPR[1].itens = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getEPIPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetEPIByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.dataItensAPR[0].itens = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getRiscosEspeciaisPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetRiscosEspeciaisByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.dataItensAPR[2].itens = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getCursosNRPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetCursosNRByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.dataItensAPR[3].itens = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/details/components/aprItemDetails/aprItemDetails.js